import React, { useState } from 'react';
import VouchersForm from './VouchersForm';
import { Button } from 'reactstrap';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import { putAPI_Update_Vouchers } from '../../../../../../../constants/APIs';
import PropTypes from 'prop-types';
import BuyOptionForm from './BuyoptionForm';
import Validation from '../../../../../../../components/Validation';
export default function UpdateVouchersForm({ id, propertyId,amadeus,xolaIntegration, optionId, isBuyOption, extractData,voucherName }) {
  const [isUpdating, setIsUpdating] = useState(false);
  const [isBuyOptionForm, setisBuyOptionForm] = useState(false);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const handleSubmit = (data) => {
    const formmatedData = { ...data, updater: 'admin' };
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_Vouchers}/${id}`,
      data: formmatedData,
    }).then((res) => {
      if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
        && res.data.Messages !== null && res.data.Messages.length > 0) {
        setMsg(res.data.Messages);
        setOpen(true);
    }
    else {
      extractData();
      if (isBuyOption) {
        setisBuyOptionForm(!isBuyOptionForm);
      } else {
        setIsUpdating(!isUpdating);
      }
    }
    });
  };
  return (
    <div>
      {isBuyOption ? <Button
        color="primary"
        size="sm"
        onClick={() => setisBuyOptionForm(!isBuyOptionForm)}
      >
        Edit
      </Button> :
        <Button
          color="primary"
          size="sm"
          onClick={() => setIsUpdating(!isUpdating)}
        >
          Edit
        </Button>}
      {isUpdating && (
        <VouchersForm
          formLabel="Update the Voucher"
          visible={isUpdating}
          toggle={() => {
            setIsUpdating(!isUpdating);
          }}
          id={id}
          submit={handleSubmit}
          propertyId={propertyId}
        />
      )}
      {isBuyOptionForm && (<BuyOptionForm
        formLabel="Update a voucher variant"
        visible={isBuyOptionForm}
        toggle={() => {
          setisBuyOptionForm(!isBuyOptionForm);
        }}
        id={id}
        amadeus={amadeus}
        xolaIntegration={xolaIntegration}
        optionId={optionId}
        submit={handleSubmit}
        voucherName={voucherName}
        propertyId={propertyId}
        extractData={extractData}
        update={true}
      />)}
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </div>
  );
}

UpdateVouchersForm.propTypes = {
  id: PropTypes.string.isRequired,
};
